import * as React from 'react';
import { MapOnboardingTooltip } from '../../../MapOnboardingTooltip';

import { MapRouteOnboardingContent } from '../MapRouteOnboardingContent';

export interface IMapRouteOnboardingProps {
  children: React.ReactElement;
  onClose(): void;
  open: boolean;
}

export const MapRouteOnboarding: React.FC<IMapRouteOnboardingProps> = ({ children, onClose, open }) => {
  return (
    <>
      {children}
      {open && <MapOnboardingTooltip onClose={onClose} content={<MapRouteOnboardingContent />} placement="bottom" />}
    </>
  );
};
